module.exports = __webpack_public_path__ + "media/images/WFC_Portrait_White_w_0-f1ace74e5ff02fee8480fec57f6c7ed4.svg";